<div>
  <label class="required">{{'Klient' | translate}}</label>
  <input autocomplete="off"
         [class.uk-form-danger]="clientInput.touched && id_client.value == ''"
         (keyup)="searchClient(clientInput)"
         type="text"
         #clientInput="ngModel"
         name="client"
         [(ngModel)]="clientName"
         [disabled]="false === isCreatingForm"
         class="uk-input"
         required
         #clientField
  >

  <div style="position: absolute; max-height: 200px;" class="uk-overflow-auto">
    <ul class="uk-list uk-list-divider uk-position-relative uk-margin-remove-top"
        id="clientChooseList"
        style="background-color: white; width: 100%;"
        *ngIf="clients.length > 0"
        [style.width]="clientField.clientWidth + 'px'"
    >
      <li *ngFor="let client of clients; let i = index" (click)="setClient(client);" style="padding-left: 10px" id="clientChooseListElement_{{i}}"><!-- poprawcować nad paddingiem i obsługą przyciskami-->
        {{client.name}}
      </li>
    </ul>
  </div>

  <input type="hidden"
         #id_client="ngModel"
         autocomplete="none"
         name="id_client"
         [(ngModel)]="clientId"
         class="uk-input"
  >
</div>
